import { render } from "./NotificationStack.vue?vue&type=template&id=d6bf0b5a"
import script from "./NotificationStack.vue?vue&type=script&lang=js"
export * from "./NotificationStack.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\optometry-academy-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__